export default __webpack_public_path__ + "static/4-9be69cd7e26bb2fbfffe6d9217492210.png";